//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import userChecks from '~/mixins/userChecks';
export default {
  mixins: [userChecks],
  props: ['title', 'slug', 'slugTitle', 'directlogo', 'type'],
};
